var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-plant", {
                  attrs: { type: "search", name: "plantCd" },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-datepicker", {
                  attrs: {
                    range: true,
                    defaultStart: "-1M",
                    defaultEnd: "0M",
                    label: "LBL0000201",
                    name: "permitDates",
                  },
                  model: {
                    value: _vm.searchParam.permitDates,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "permitDates", $$v)
                    },
                    expression: "searchParam.permitDates",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-dept", {
                  attrs: {
                    type: "search",
                    label: "LBL0000202",
                    name: "applicationDeptCd",
                  },
                  model: {
                    value: _vm.searchParam.applicationDeptCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "applicationDeptCd", $$v)
                    },
                    expression: "searchParam.applicationDeptCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-dept", {
                  attrs: {
                    isFirstValue: false,
                    type: "search",
                    label: "LBL0000203",
                    name: "issuedDeptCd",
                  },
                  model: {
                    value: _vm.searchParam.issuedDeptCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "issuedDeptCd", $$v)
                    },
                    expression: "searchParam.issuedDeptCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-select", {
                  attrs: {
                    type: "search",
                    codeGroupCd: "SOP_SUPPLEMENT_WORK_TYPE_CD",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "supplementWorkTypeCd",
                    label: "LBL0000205",
                  },
                  model: {
                    value: _vm.searchParam.supplementWorkTypeCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "supplementWorkTypeCd", $$v)
                    },
                    expression: "searchParam.supplementWorkTypeCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-select", {
                  attrs: {
                    type: "search",
                    stepperGrpCd: "SWP_STEP_CD",
                    itemText: "stepperMstNm",
                    itemValue: "stepperMstCd",
                    name: "swpStepCd",
                    label: "LBLSTEPPROGRESS",
                  },
                  model: {
                    value: _vm.searchParam.swpStepCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "swpStepCd", $$v)
                    },
                    expression: "searchParam.swpStepCd",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          attrs: {
            title: "LBL0000210",
            columns: _vm.grid.columns,
            data: _vm.grid.data,
          },
          on: { linkClick: _vm.linkClick },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  _vm._v(" " + _vm._s(props.row[col.name]) + " "),
                  props.row.swpWorkRequestName
                    ? [
                        _vm._v(" - "),
                        _c(
                          "q-badge",
                          {
                            attrs: { outline: "", align: "top", color: "teal" },
                          },
                          [
                            _vm._v(
                              " 업체 " +
                                _vm._s(props.row.swpWorkRequestName) +
                                " 요청 "
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable
                    ? _c("c-btn", {
                        attrs: { label: "등록", icon: "add" },
                        on: { btnClicked: _vm.addWorkPermit },
                      })
                    : _vm._e(),
                  _c("c-btn", {
                    attrs: { label: "LBL0000209", icon: "search" },
                    on: { btnClicked: _vm.getList },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }